var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio"},[_c('div',{staticClass:"headline"},[_c('h1',{staticClass:"headline_title title-fade"},[_vm._v("Портфолио")]),_vm._v(" "),_c('Filters')],1),_vm._v(" "),_c('div',{staticClass:"portfolio_content"},_vm._l((_vm.portfolio),function(item,index){return _c('Preview',{key:item.id,attrs:{"item":item}})})),_vm._v(" "),_c('Form')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d1319c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/portfolio/Portfolio.html
// module id = null
// module chunks = 